package link.erpango.quip.ui.ocr

import androidx.compose.runtime.Composable
import link.erpango.quip.domain.ocr.OcrError
import org.jetbrains.compose.resources.stringResource
import quip.composeapp.generated.resources.Res
import quip.composeapp.generated.resources.note_import_ocr_error_decode
import quip.composeapp.generated.resources.note_import_ocr_error_too_large
import quip.composeapp.generated.resources.note_import_ocr_error_permission
import quip.composeapp.generated.resources.note_import_ocr_error_recognition
import quip.composeapp.generated.resources.note_import_ocr_error_unsupported

/**
 * Maps a typed OCR failure to a readable, translatable message. Shared by the image picker flow
 * and the photo capture screen.
 */
@Composable
internal fun ocrErrorMessage(error: OcrError): String = when (error) {
    OcrError.UnsupportedPlatform -> stringResource(Res.string.note_import_ocr_error_unsupported)
    OcrError.PermissionDenied -> stringResource(Res.string.note_import_ocr_error_permission)
    OcrError.DecodeFailed -> stringResource(Res.string.note_import_ocr_error_decode)
    OcrError.ImageTooLarge -> stringResource(Res.string.note_import_ocr_error_too_large)
    is OcrError.RecognitionFailed -> stringResource(Res.string.note_import_ocr_error_recognition)
}
